import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Leads from "./Leads/Leads";

function DashboardLeads() {
	return (
		<ToastProvider>
			<Dashboard>
				<Leads />
			</Dashboard>
			<Toast />
		</ToastProvider>
	)
}

export default DashboardLeads